import React, { useMemo, useState } from 'react';
import { FaQuestion } from 'react-icons/fa';
import KvizPitanjeConnect from './KvizPitanjeConnect';
import KvizPitanjeMulti from './KvizPitanjeMulti';
import KvizPitanjeSingle from './KvizPitanjeSingle';
import { Odgovor } from '../LekcijaObrazovanjeHome';

import { RefObject } from 'react';
import MDEditor from '@uiw/react-md-editor';
import { mathPlugins } from '../../../utils/markdownMath';
import { MarkDownView } from '../../common/MarkDownView';

function TestoviZaLekciju({
    lekcija,
    kvizPitanja,
    currentIndex,
    datiOdgovori,
    handleOdgovor,
    surveyOdgovori,
    setSurveyOdgovori,
    showResults,
    closeSurvey,
    closeTestZnanja,
    ukupnoBodova,
    surveyMode,
}: {
    lekcija: any;
    kvizPitanja: any[];
    currentIndex: number;
    datiOdgovori: any[];
    handleOdgovor: (odgovor: any) => void;
    surveyOdgovori: any[];
    setSurveyOdgovori: (odgovori: any[]) => void;
    showResults: boolean;
    closeSurvey: () => void;
    closeTestZnanja: () => void;
    ukupnoBodova: number;
    surveyMode: boolean;
}) {
    const [showUpozorenje, setShowUpozorenje] = useState(false);

    // Redni brojevi pitanja koja nisu popunjena: Single/Multi bez izabrane opcije, Connect bez svih povezanih parova
    const nepopunjena = useMemo(() => {
        const lista: number[] = [];
        kvizPitanja.forEach((item: any, index: number) => {
            const odg = surveyOdgovori?.[index];
            let popunjeno = false;
            if (item.vrsta === 'Single') popunjeno = !!odg?.odgovor;
            else if (item.vrsta === 'Multi') popunjeno = (odg?.odgovori?.length ?? 0) > 0;
            else if (item.vrsta === 'Connect') popunjeno = Object.keys(odg?.odgovor || {}).length >= (item.listA?.length ?? 0);
            else popunjeno = true;
            if (!popunjeno) lista.push(index + 1);
        });
        return lista;
    }, [kvizPitanja, surveyOdgovori]);

    const handleZavrsiTest = () => {
        if (nepopunjena.length > 0) setShowUpozorenje(true);
        else closeSurvey();
    };

    return (
        <div className="w-full bg-white flex flex-col pt-[30px] pb-[60px] rounded-[10px]">
            <div className="grid grid-cols-2 gap-4">
                <div className=" bg-schoolBoardDark rounded-r-lg p-3  ">
                    <p className={`text-white text-[16px] lg:text-[24px] font-medium lg:font-semibold `}>{lekcija?.naziv}</p>
                </div>
                <div className=" bg-greyMedium rounded-l-lg p-3 ">
                    {/* Na mobilnom opis ide do četiri reda sa tačkicama i manjim razmakom, da traka sa dugmetom "Prekini" ostane vidljiva */}
                    <div className="max-md:line-clamp-4 max-md:[&_*]:!leading-[18px] max-md:[&_p]:!my-0">
                        <MarkDownView
                            source={lekcija?.opis}
                            nazivKlase="lekcija-opis"
                            style={{ color: 'white', textAlign: 'left', backgroundColor: 'transparent' }}
                        />
                    </div>
                </div>
            </div>
            <div id="kviz-traka" className="grid grid-cols-12 gap-2 mt-5">
                <div className="col-span-11 bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                    <p className="lekcija-naziv tracking-tight">
                        {surveyMode && !showResults
                            ? lekcija?.isSurvey
                                ? 'Pripremni test'
                                : 'Kviz zadaci za proveru znanja'
                            : surveyMode && showResults
                              ? `${ukupnoBodova}/${kvizPitanja.length} bodova osvojenih.`
                              : 'Kviz zadaci za proveru znanja'}
                    </p>
                    <button onClick={closeTestZnanja} className="start-button">
                        Prekini
                    </button>
                </div>
                {/* {!lekcija.isSurvey ? (
                                    <div className="col-span-12 md:col-span-1 flex  items-center justify-center">
                                        <p className="text-blueMedium text-[24px] leading-7 font-bold text-center ">
                                            {currentIndex + 1}/{kvizPitanja.length}
                                        </p>
                                    </div>
                                ) : (
                                    <div className="col-span-12 md:col-span-1 flex  items-center justify-center">
                                        <p className="text-blueMedium text-[24px] leading-7 font-bold text-center ">
                                            {brojNenullElemenata}/{kvizPitanja.length}
                                        </p>
                                    </div>
                                )} */}
            </div>
            {!surveyMode && (
                <div className=" pb-5 px-3 md:px-20 w-full flex flex-col items-center">
                    <div className="flex flex-row items-center gap-2 mt-5  w-full max-w-[450px] ">
                        <div className="h-[60px] min-w-[60px] border border-blueMedium rounded-full justify-center items-center flex">
                            <FaQuestion size={35} color="#234b98" />
                        </div>
                        <MDEditor.Markdown {...mathPlugins} className="test-znanja-naziv" source={kvizPitanja[currentIndex]?.naziv} />
                    </div>
                    <div className="h-[1px] w-full max-w-[450px] bg-blueMedium mt-5"></div>
                    <div className="w-full flex flex-col items-center gap-4 mt-6">
                        {kvizPitanja[currentIndex] &&
                            kvizPitanja[currentIndex]?.odgovori?.map((odgovor: any, index: number) => {
                                return (
                                    <Odgovor
                                        odgovor={odgovor}
                                        handleOdgovor={handleOdgovor}
                                        currentIndex={currentIndex}
                                        datiOdgovori={datiOdgovori}
                                        key={odgovor?.id}
                                    />
                                );
                            })}
                    </div>
                </div>
            )}
            {surveyMode && (
                <div>
                    <div className="w-full flex flex-col gap-3  py-5 px-2 md:px-5">
                        {kvizPitanja.map((item: any, index: number) => {
                            return item.vrsta === 'Single' ? (
                                <KvizPitanjeSingle
                                    item={item}
                                    pitanjeIndex={index}
                                    surveyOdgovori={surveyOdgovori}
                                    setSurveyOdgovori={setSurveyOdgovori}
                                    showResults={showResults}
                                    key={item.id}
                                />
                            ) : item.vrsta === 'Connect' ? (
                                <KvizPitanjeConnect
                                    item={item}
                                    listA={item.listA}
                                    listB={item.listB}
                                    pitanjeIndex={index}
                                    surveyOdgovori={surveyOdgovori}
                                    setSurveyOdgovori={setSurveyOdgovori}
                                    showResults={showResults}
                                    key={item.id}
                                />
                            ) : item.vrsta === 'Multi' ? (
                                <KvizPitanjeMulti
                                    item={item}
                                    pitanjeIndex={index}
                                    surveyOdgovori={surveyOdgovori}
                                    setSurveyOdgovori={setSurveyOdgovori}
                                    showResults={showResults}
                                    key={item.id}
                                />
                            ) : (
                                <div>default</div>
                            );
                        })}
                    </div>
                    {!showResults && (
                        <div className="w-full flex items-center justify-center">
                            <button
                                type="button"
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleZavrsiTest();
                                }}
                                className="start-button"
                            >
                                Završi test
                            </button>
                        </div>
                    )}

                    {showUpozorenje && !showResults && (
                        <div className="fixed inset-0 z-[50] bg-black/50 flex items-center justify-center px-4">
                            <div className="bg-white rounded-[10px] p-4 sm:p-5 max-w-[420px] w-full max-h-[90dvh] overflow-y-auto flex flex-col gap-3 shadow-xl">
                                <p className="text-[18px] leading-6 text-blueDark font-bold">Niste popunili sva pitanja</p>
                                <p className="text-[16px] leading-5 text-blueDark">
                                    Nepopunjena pitanja ({nepopunjena.length}): {nepopunjena.join(', ')}. Kod pitanja sa jednim ili više odgovora izaberite bar jednu opciju, a kod
                                    povezivanja povežite sve stavke.
                                </p>
                                <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end mt-2">
                                    <button type="button" onClick={() => setShowUpozorenje(false)} className="start-button w-full sm:w-auto">
                                        Vrati se na test
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowUpozorenje(false);
                                            closeSurvey();
                                        }}
                                        className="text-[16px] leading-5 text-white bg-[#dc3545] font-medium px-4 py-2 rounded-[10px] transition w-full sm:w-auto"
                                    >
                                        Završi svejedno
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {showResults && (
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-11 bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                                <p className="lekcija-naziv tracking-tight">
                                    {ukupnoBodova}/{kvizPitanja.length} bodova osvojenih.
                                </p>
                                <button onClick={closeTestZnanja} className="start-button">
                                    Prekini
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default TestoviZaLekciju;
